<template>
  <div class="flexwrap centercenter">
    <div class="horizontalGrid flexwrap">
      <div class="stepGrid" v-for="n in nbSteps" :key="n">
          <div class="stepNumberGrid">
            <div class="stepNumber" :class="[currentStep > n ? 'number-check' : 'navTheme']"><strong>{{n}}</strong></div>
            <div class="stepNumber-line" :class="[currentStep > n-1 ? 'line-check' : 'navTheme', n ===1 ? 'firstStep-line': '']"></div>
            <div class="stepNumber-line" :class="[currentStep > n ? 'line-check' : 'navTheme', n >=3 ? 'lastStep': '']"></div>
          </div>
          <div class="stepLine" :class="[currentStep > n ? 'line-check' : 'navTheme', n >=3 ? 'lastStep': '']"></div>
          <span class="stepName" :class="[currentStep > n ? 'name-check' : 'name-uncheck']">{{steps[n-1]}}</span>
      </div>
    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "stepper",

  props: {
    steps: Array,
    currentStep: Number
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
    nbSteps: function () {
      return this.steps.length
    }
  },

  data() {
    return {

    }
  }
}
</script>

<style scoped>

  .horizontalGrid{
    display: grid;
    grid-auto-flow: row;
    grid-template-columns: 1fr 1fr 1fr;
    width: min-content;
  }

  .stepGrid{
    width: auto;
    display: grid;
    grid-template-columns: min-content auto;
    grid-template-rows: 1fr 1fr auto;
  }

  .stepNumberGrid{
    display: grid;
    grid-template-rows: auto auto;
    grid-template-columns: auto min-content auto;
    grid-auto-flow: row;
    width: content-box;
    grid-row: 1/3;
    grid-colum: 1/2;

  }

  .stepNumber{
    width: 1vw;
    grid-row: 1/3;
    grid-column: 2/3;
    border-radius: 3vw;
    height: 1vw;
    text-align: center;
    align-self: center;
    padding: 1vw 1vw 1vw 1vw;
  }

  .stepNumber-line{
    width: 100%;
    grid-row: 1/3;
    height: 0.25vw;
    align-self: center;
  }

  .stepLine{
    width: 100%;
    grid-row: 1/3;
    grid-column: 2/3;
    height: 0.5vw;
    align-self: center;
  }

  .stepName{
    grid-row: 3/4;
    color: #393939;
    white-space: nowrap;
    non-wrap : nowrap;
    padding: 0.25vw 2vw 0.25vw 2vw;
    font-weight: bold;
  }

  .lastStep{
    width: 0px;
  }

  .firstStep-line{
    width: 0px;
  }

  .number-uncheck{
    color: var(--standardColor);
    background-color: var(--silverDarkColor);
  }

  .line-uncheck{
    background-color: var(--silverDarkColor);
  }

  .name-uncheck{
    color: var(--standardColor);
  }

  .number-check{
    color: var(--goalColor);
    background-color: var(--goalBackgroundColor2);
  }

  .line-check{
    background-color: var(--goalBackgroundColor2);
  }

  .name-check{
    color: var(--goalBackgroundColor2);
  }

  @media screen and (max-device-width: 767px) {

    .horizontalGrid{
      margin-top: 2vw;
    }

    .stepNumber{
      width: 4vw;
      grid-row: 1/3;
      grid-column: 2/3;
      border-radius: 4vw;
      height: 4vw;
      text-align: center;
      align-self: center;
      padding: 1vw 1vw 1vw 1vw;
    }

  }
</style>